import { useLoanProcessView } from '../hooks/use-loan-process-view';
import { LoanProcessModalComponent } from './loan-process-modal-component';
import { useLoanProcessStore } from '../store/loan-process.store';

export function LoanProcessModal() {
  const currentComponent = useLoanProcessView();
  const {
    state: { loanProcessState },
  } = useLoanProcessStore();
  if (currentComponent) {
    return (
      <LoanProcessModalComponent loanProcessState={loanProcessState}>
        {currentComponent}
      </LoanProcessModalComponent>
    );
  }

  return null;
}
